import { Pane } from '@elfsight/widget-modal';
import { Background } from '@elfsight/widget-ui';
import { usePopup, useThumbnailMode } from '../../../../utils';
import { Content } from '../../content';
import type { LayoutVariationProps } from './types';

export function LayoutPane({
  show,
  width,
  position,
  overlayProps: { visible, closeOnClick, background },
  controls: { closeButtonVisible, closeButtonColor },
  ariaLabel,
  ...props
}: LayoutVariationProps) {
  const { close } = usePopup();
  const { styles: thumbnailStyles, thumbnailMode } = useThumbnailMode({
    withHeight: true,
    withWidth: true
  });

  return (
    <Pane
      ariaLabel={ariaLabel}
      show={show}
      width={width}
      position={position}
      withBackdrop={visible && !thumbnailMode}
      backdropComponent={
        <Background {...background} style={{ position: 'fixed' }} />
      }
      onCloseRequest={close}
      closeOnOutsideClick={closeOnClick}
      withCloseControl={closeButtonVisible}
      closeControlColor={closeButtonColor}
      style={thumbnailStyles}
      closeOnEscape
      disableScroll
      fixed
    >
      <Content {...props} popupShowing={show} />
    </Pane>
  );
}
